import useGraphqlQuery from '@elementary/common-ui/hooks/useGraphqlQuery';
import { PIPELINE_RUN } from '@elementary/common-ui/constants/queryKeys';
import useEnvironments from 'shared/hooks/useEnvironments';
import { PipelineRunData, PipelineRunResponse } from '../types';
import * as api from '../api';

const usePipelineRun = (eventId?: string) => {
  const { selectedEnvId } = useEnvironments();

  const { data, isLoading, error } = useGraphqlQuery<{
    pipelineRun: PipelineRunResponse | null;
  }>({
    queryKey: [PIPELINE_RUN, eventId, selectedEnvId],
    query: api.getPipelineRunQuery,
    variables: { eventId },
    enabled: !!eventId,
  });

  const raw = data?.pipelineRun;
  const pipelineRunData: PipelineRunData | undefined = raw
    ? {
        event: raw.event,
        rawStatus: raw.rawStatus,
        status: raw.status || 'error',
        failureReason: raw.failureReason ?? undefined,
        eventTimestamp: raw.eventTimestamp,
        syncId: raw.syncId,
        taskType: raw.taskType ?? undefined,
        rescheduledAt: raw.rescheduledAt ?? undefined,
        connectorName: raw.connectorName ?? undefined,
        connectorType: raw.connectorType ?? undefined,
        toolType: raw.toolType ?? undefined,
        connectorId: raw.connectorId ?? undefined,
        destination: raw.destination ?? undefined,
      }
    : undefined;

  return { data: pipelineRunData, isLoading, error };
};

export default usePipelineRun;
